<template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
                router unique-opened
                :default-active="activeMenu"
                background-color="rgb(48, 65, 86)"
                text-color="#fff"
                :collapse="menuCollapse">
            <side-bar-item v-for="menu in menus" :key="menu.id" :menu="menu"></side-bar-item>
        </el-menu>
    </el-scrollbar>
</template>

<script>
    import SideBarItem from '@/components/sidebar/SideBarItem'
    export default {
        name: "SideBar",
        components: {SideBarItem},
        data(){
            return{
                basePath: this.feUrl,
                menus: [],
            }
        },
        props: ['menuCollapse'],
        computed: {
            /*menus () {
                return [{
                    icon: "el-icon-menu",
                    id: 1,
                    menuName: "首页",
                    parentId: 0,
                    path: this.basePath + "/home.html",
                }, {
                    icon: "el-icon-s-flag",
                    id: 2,
                    menuName: "管理员管理",
                    parentId: 0,
                    path: "",
                    children: [{
                        icon: "el-icon-user",
                        id: 6,
                        menuName: "管理员列表",
                        parentId: 5,
                        path: this.basePath + "/admin.html",
                    }, {
                        icon: "el-icon-menu",
                        id: 3,
                        menuName: "菜单管理",
                        parentId: 2,
                        path: this.basePath + "/menu.html",
                    }, {
                        icon: "el-icon-bank-card",
                        id: 4,
                        menuName: "角色管理",
                        parentId: 2,
                        path: this.basePath + "/role.html"
                    }]
                }, {
                    icon: "el-icon-user",
                    id: 7,
                    menuName: "用户管理",
                    parentId: 0,
                    path: this.basePath + "/user.html",
                }, {
                    icon: "el-icon-info",
                    id: 8,
                    menuName: "个人管理",
                    parentId: 0,
                    path: "",
                    children: [{
                        icon: "el-icon-info",
                        id: 9,
                        menuName: "我的信息",
                        parentId: 8,
                        path: this.basePath + "/myInfo.html",
                    }, {
                        icon: "el-icon-s-cooperation",
                        id: 10,
                        menuName: "修改密码",
                        parentId: 8,
                        path: this.basePath + "/password.html",
                    }]
                }];
            },*/
            activeMenu () {
                const route = this.$route;
                const {meta, path} = route;
                if (meta.activeMenu) {
                    return meta.activeMenu;
                }
                return path;
            },
        },
        mounted(){
            this.getMenus();
        },
        methods: {
            normalizeMenuPath(menuPath){
                const path = (menuPath || '').trim();
                if (!path || path === this.basePath || path.indexOf(this.basePath + '/') === 0) {
                    return path;
                }
                return this.basePath + '/' + path.replace(/^\/+/, '');
            },
            getMenus(){
                this.$axios.post({
                    url: '/roleMenu/menus',
                    success: (res) => {
						console.log(res)
                        let menus = [];
                        //过滤掉重复菜单
                        /*console.log(res)
                        console.log(menus)*/
                        for (let i = 0; i < res.data.length; i++) {
                            let index = -1;
                            for (let j = 0; j < menus.length; ++j) {
                                if (menus[j].id === res.data[i].id) {
                                    index = j;
                                }
                            }
                            if (index === -1) {
                                res.data[i].path = this.normalizeMenuPath(res.data[i].path);
                                menus.push(res.data[i]);
                            }
                        }
                        this.menus = this.$toTree.toTree(menus);
						console.log(this.menus)
                    },
                    error: () => {
                        this.$message.error('出错了');
                    }
                })
            },
        },

    }
</script>

<style scoped>
    .el-menu:not(.el-menu--collapse) {
        width: 225px;
        min-height: 400px;
    }
    .el-menu {
        border: none;
    }
</style>
